import { useCallback, useContext, useEffect } from 'react';
import type { CanvasTexture } from 'three';
import { LabDevTexturesContext } from './LabDevTextures';

export default function useLabDevTextures(productId: number | null, variant: string) {
  const textures = useContext(LabDevTexturesContext);

  useEffect(() => () => {
    if (textures) textures.current = null;
  }, [textures, productId, variant]);

  return useCallback((artwork: CanvasTexture, effects?: CanvasTexture) => {
    if (textures) textures.current = { artwork, effects };
  }, [textures]);
}
